export const IS_DEV = process.env.NODE_ENV === 'development';

export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_PAGE = 0;
